export default __webpack_public_path__ + "static/media/Lancero.f528a674.png";